/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';
import Button from '../Button';

function ReadyToTransformSection() {
    const { theme } = useTheme();

    return (
        <section id="contact" className="py-5 bg-white">
            <div className="container py-5 text-center">
                <h2 className="fw-bold display-5 mb-4" style={{ color: theme.primary }}>
                    Ready to transform?
                </h2>
                <p className="lead text-muted mb-4">
                    Get in touch with our enterprise experts.
                </p>
                <a
                    href="mailto:info@rudracoresoft.com"
                    className="btn btn-lg px-5 py-3 rounded-pill fw-bold text-white shadow-sm"
                    style={{ background: theme.gradientBackground, border: 'none' }}
                >
                    info@rudracoresoft.com
                </a>
                <div className="mt-4 text-muted small">
                    © 2025 Rudra Coresoft Pvt Ltd. Bangalore, India. All Rights Reserved.
                </div>
            </div>
        </section>
    );
}

export default ReadyToTransformSection;
